import {ID, Model} from 'simpli-web-sdk'

export default class DevolverNota extends Model {
  idCarga: ID = 0
  password: String | null = null

}
